import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.5,
      color: theme.palette.text.primary,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
    },
  }),
  { name: 'ContentSimple' }
);
